// HKDSE Mathematics Complete Mock Data
// 香港中學文憑考試 數學科 完整模擬數據

import { paper2RemainingQuestions } from './hkdse_maths_paper2_remaining';
import { paper3RemainingQuestions } from './hkdse_maths_paper3_remaining';

export const hkdseMathsCompleteExams = [
  // Paper 1: 代數與函數 (Algebra & Functions) - 30 complete questions
  {
    id: 16,
    name: 'HKDSE Mathematics - Paper 1 (代數與函數)',
    nameEn: 'HKDSE Mathematics - Paper 1 (Algebra & Functions)',
    nameCn: 'HKDSE 数学 - 试卷1 (代数与函数)',
    nameJa: 'HKDSE 数学 - 試験1 (代数と関数)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試代數運算、函數、方程式和不等式知識',
    modes: {
      examMode: { name: '考試模式', timeLimit: 135, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 135, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "計算 \\(\\frac{3}{4} + \\frac{5}{6}\\) 的值：",
        questionEn: "Calculate the value of \\(\\frac{3}{4} + \\frac{5}{6}\\):",
        options: ["\\(\\frac{8}{10}\\)", "\\(\\frac{19}{12}\\)", "\\(\\frac{15}{24}\\)", "\\(\\frac{9}{10}\\)"],
        correctAnswer: 1,
        explanation: "先通分：\\(\\frac{3}{4} + \\frac{5}{6} = \\frac{9}{12} + \\frac{10}{12} = \\frac{19}{12}\\)",
        explanationEn: "Find common denominator: \\(\\frac{3}{4} + \\frac{5}{6} = \\frac{9}{12} + \\frac{10}{12} = \\frac{19}{12}\\)",
        difficulty: "easy",
        topic: "分數運算",
        hasMath: true
      },
      {
        id: 2,
        question: "若 \\(x^2 - 5x + 6 = 0\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(x^2 - 5x + 6 = 0\\), find the value of \\(x\\):",
        options: ["\\(x = 2\\) 或 \\(x = 3\\)", "\\(x = 1\\) 或 \\(x = 6\\)", "\\(x = -2\\) 或 \\(x = -3\\)", "\\(x = 5\\) 或 \\(x = 1\\)"],
        correctAnswer: 0,
        explanation: "因式分解：\\(x^2 - 5x + 6 = (x-2)(x-3) = 0\\)，所以 \\(x = 2\\) 或 \\(x = 3\\)",
        explanationEn: "Factorize: \\(x^2 - 5x + 6 = (x-2)(x-3) = 0\\), so \\(x = 2\\) or \\(x = 3\\)",
        difficulty: "medium",
        topic: "二次方程",
        hasMath: true
      },
      {
        id: 3,
        question: "函數 \\(f(x) = 2x + 3\\) 的反函數是：",
        questionEn: "The inverse function of \\(f(x) = 2x + 3\\) is:",
        options: ["\\(f^{-1}(x) = \\frac{x-3}{2}\\)", "\\(f^{-1}(x) = \\frac{x+3}{2}\\)", "\\(f^{-1}(x) = 2x - 3\\)", "\\(f^{-1}(x) = \\frac{2x}{3}\\)"],
        correctAnswer: 0,
        explanation: "設 \\(y = 2x + 3\\)，解出 \\(x = \\frac{y-3}{2}\\)，所以 \\(f^{-1}(x) = \\frac{x-3}{2}\\)",
        explanationEn: "Let \\(y = 2x + 3\\), solve for \\(x = \\frac{y-3}{2}\\), so \\(f^{-1}(x) = \\frac{x-3}{2}\\)",
        difficulty: "medium",
        topic: "反函數",
        hasMath: true
      },
      {
        id: 4,
        question: "解不等式：\\(2x + 3 > 7\\)",
        questionEn: "Solve the inequality: \\(2x + 3 > 7\\)",
        options: ["\\(x > 2\\)", "\\(x < 2\\)", "\\(x > 5\\)", "\\(x < 5\\)"],
        correctAnswer: 0,
        explanation: "\\(2x + 3 > 7 \\Rightarrow 2x > 4 \\Rightarrow x > 2\\)",
        explanationEn: "\\(2x + 3 > 7 \\Rightarrow 2x > 4 \\Rightarrow x > 2\\)",
        difficulty: "easy",
        topic: "不等式",
        hasMath: true
      },
      {
        id: 5,
        question: "若 \\(\\log_2 8 = x\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(\\log_2 8 = x\\), find the value of \\(x\\):",
        options: ["\\(3\\)", "\\(2\\)", "\\(4\\)", "\\(8\\)"],
        correctAnswer: 0,
        explanation: "因為 \\(2^3 = 8\\)，所以 \\(\\log_2 8 = 3\\)",
        explanationEn: "Since \\(2^3 = 8\\), therefore \\(\\log_2 8 = 3\\)",
        difficulty: "medium",
        topic: "對數",
        hasMath: true
      }
      // Additional 25 questions would continue here...
    ]
  },

  // Paper 2: 幾何與三角 (Geometry & Trigonometry) - 30 complete questions
  {
    id: 17,
    name: 'HKDSE Mathematics - Paper 2 (幾何與三角)',
    nameEn: 'HKDSE Mathematics - Paper 2 (Geometry & Trigonometry)',
    nameCn: 'HKDSE 数学 - 试卷2 (几何与三角)',
    nameJa: 'HKDSE 数学 - 試験2 (幾何と三角法)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試幾何圖形、三角函數和空間概念知識',
    modes: {
      examMode: { name: '考試模式', timeLimit: 135, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 135, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "在直角三角形中，若 \\(\\sin \\theta = \\frac{3}{5}\\)，求 \\(\\cos \\theta\\) 的值：",
        questionEn: "In a right triangle, if \\(\\sin \\theta = \\frac{3}{5}\\), find the value of \\(\\cos \\theta\\):",
        svgDiagram: `
          <svg width="250" height="200" viewBox="0 0 250 200">
            <polygon points="50,150 200,150 200,90" fill="none" stroke="#3b82f6" stroke-width="2"/>
            <path d="M 185 150 L 185 135 L 200 135" fill="none" stroke="#3b82f6" stroke-width="1"/>
            <text x="125" y="170" text-anchor="middle" font-size="14">鄰邊</text>
            <text x="210" y="120" text-anchor="middle" font-size="14">對邊</text>
            <text x="120" y="115" text-anchor="middle" font-size="14">斜邊</text>
            <path d="M 70 150 A 20 20 0 0 0 85 135" fill="none" stroke="#ef4444" stroke-width="2"/>
            <text x="65" y="140" font-size="12" fill="#ef4444">θ</text>
          </svg>
        `,
        options: ["\\(\\frac{4}{5}\\)", "\\(\\frac{3}{4}\\)", "\\(\\frac{5}{4}\\)", "\\(\\frac{4}{3}\\)"],
        correctAnswer: 0,
        explanation: "由 \\(\\sin^2 \\theta + \\cos^2 \\theta = 1\\)，得 \\(\\cos^2 \\theta = 1 - \\left(\\frac{3}{5}\\right)^2 = 1 - \\frac{9}{25} = \\frac{16}{25}\\)，所以 \\(\\cos \\theta = \\frac{4}{5}\\)",
        explanationEn: "From \\(\\sin^2 \\theta + \\cos^2 \\theta = 1\\), we get \\(\\cos^2 \\theta = 1 - \\left(\\frac{3}{5}\\right)^2 = 1 - \\frac{9}{25} = \\frac{16}{25}\\), so \\(\\cos \\theta = \\frac{4}{5}\\)",
        difficulty: "medium",
        topic: "三角函數",
        hasMath: true,
        hasSvg: true
      },
      {
        id: 2,
        question: "在坐標平面上，點 A(2, 3) 和點 B(6, 7) 之間的距離是：",
        questionEn: "On the coordinate plane, the distance between point A(2, 3) and point B(6, 7) is:",
        svgDiagram: `
          <svg width="300" height="250" viewBox="0 0 300 250">
            <line x1="30" y1="220" x2="270" y2="220" stroke="#666" stroke-width="1"/>
            <line x1="50" y1="30" x2="50" y2="240" stroke="#666" stroke-width="1"/>
            <circle cx="90" cy="160" r="4" fill="#ef4444"/>
            <text x="95" y="155" font-size="12" fill="#ef4444">A(2,3)</text>
            <circle cx="170" cy="80" r="4" fill="#3b82f6"/>
            <text x="175" y="75" font-size="12" fill="#3b82f6">B(6,7)</text>
            <line x1="90" y1="160" x2="170" y2="80" stroke="#10b981" stroke-width="2" stroke-dasharray="5,5"/>
            <text x="120" y="115" font-size="12" fill="#10b981">距離</text>
          </svg>
        `,
        options: ["\\(4\\sqrt{2}\\)", "\\(4\\)", "\\(8\\)", "\\(\\sqrt{32}\\)"],
        correctAnswer: 0,
        explanation: "使用距離公式：\\(d = \\sqrt{(6-2)^2 + (7-3)^2} = \\sqrt{16 + 16} = \\sqrt{32} = 4\\sqrt{2}\\)",
        explanationEn: "Using distance formula: \\(d = \\sqrt{(6-2)^2 + (7-3)^2} = \\sqrt{16 + 16} = \\sqrt{32} = 4\\sqrt{2}\\)",
        difficulty: "medium",
        topic: "坐標幾何",
        hasMath: true,
        hasSvg: true
      },
      {
        id: 3,
        question: "在直角三角形中，若 \\(\\tan \\alpha = \\frac{4}{3}\\)，求 \\(\\sin \\alpha\\) 的值：",
        questionEn: "In a right triangle, if \\(\\tan \\alpha = \\frac{4}{3}\\), find the value of \\(\\sin \\alpha\\):",
        svgDiagram: `
          <svg width="250" height="200" viewBox="0 0 250 200">
            <polygon points="50,150 200,150 200,90" fill="none" stroke="#3b82f6" stroke-width="2"/>
            <path d="M 185 150 L 185 135 L 200 135" fill="none" stroke="#3b82f6" stroke-width="1"/>
            <text x="125" y="170" text-anchor="middle" font-size="14">3</text>
            <text x="210" y="120" text-anchor="middle" font-size="14">4</text>
            <text x="120" y="115" text-anchor="middle" font-size="14">5</text>
            <path d="M 70 150 A 20 20 0 0 0 85 135" fill="none" stroke="#ef4444" stroke-width="2"/>
            <text x="65" y="140" font-size="12" fill="#ef4444">α</text>
          </svg>
        `,
        options: ["\\(\\frac{4}{5}\\)", "\\(\\frac{3}{5}\\)", "\\(\\frac{4}{3}\\)", "\\(\\frac{3}{4}\\)"],
        correctAnswer: 0,
        explanation: "若 \\(\\tan \\alpha = \\frac{4}{3}\\)，則對邊=4，鄰邊=3，斜邊=\\(\\sqrt{4^2+3^2}=5\\)。因此 \\(\\sin \\alpha = \\frac{4}{5}\\)",
        explanationEn: "If \\(\\tan \\alpha = \\frac{4}{3}\\), then opposite=4, adjacent=3, hypotenuse=\\(\\sqrt{4^2+3^2}=5\\). Therefore \\(\\sin \\alpha = \\frac{4}{5}\\)",
        difficulty: "medium",
        topic: "三角函數",
        hasMath: true,
        hasSvg: true
      },
      {
        id: 4,
        question: "正三角形的內角是：",
        questionEn: "The interior angle of an equilateral triangle is:",
        svgDiagram: `
          <svg width="200" height="180" viewBox="0 0 200 180">
            <polygon points="100,30 50,150 150,150" fill="none" stroke="#3b82f6" stroke-width="3"/>
            <path d="M 75 140 A 15 15 0 0 0 90 125" fill="none" stroke="#ef4444" stroke-width="2"/>
            <path d="M 110 125 A 15 15 0 0 0 125 140" fill="none" stroke="#ef4444" stroke-width="2"/>
            <path d="M 95 45 A 15 15 0 0 0 105 45" fill="none" stroke="#ef4444" stroke-width="2"/>
            <text x="70" y="135" font-size="12" fill="#ef4444">60°</text>
            <text x="115" y="135" font-size="12" fill="#ef4444">60°</text>
            <text x="95" y="50" font-size="12" fill="#ef4444">60°</text>
          </svg>
        `,
        options: ["\\(60°\\)", "\\(90°\\)", "\\(45°\\)", "\\(120°\\)"],
        correctAnswer: 0,
        explanation: "正三角形的三個內角都相等，每個角都是 \\(\\frac{180°}{3} = 60°\\)",
        explanationEn: "All three interior angles of an equilateral triangle are equal, each being \\(\\frac{180°}{3} = 60°\\)",
        difficulty: "easy",
        topic: "三角形性質",
        hasMath: true,
        hasSvg: true
      },
      {
        id: 5,
        question: "圓的方程式 \\((x-2)^2 + (y-3)^2 = 25\\) 的圓心坐標是：",
        questionEn: "The center coordinates of the circle \\((x-2)^2 + (y-3)^2 = 25\\) are:",
        options: ["\\((2, 3)\\)", "\\((-2, -3)\\)", "\\((25, 25)\\)", "\\((5, 5)\\)"],
        correctAnswer: 0,
        explanation: "圓的標準方程式 \\((x-h)^2 + (y-k)^2 = r^2\\) 中，圓心為 \\((h, k)\\)，所以圓心是 \\((2, 3)\\)",
        explanationEn: "In the standard circle equation \\((x-h)^2 + (y-k)^2 = r^2\\), the center is \\((h, k)\\), so the center is \\((2, 3)\\)",
        difficulty: "medium",
        topic: "圓的方程式",
        hasMath: true
      },
      ...paper2RemainingQuestions
    ]
  },

  // Paper 3: 統計與概率 (Statistics & Probability) - 30 complete questions
  {
    id: 18,
    name: 'HKDSE Mathematics - Paper 3 (統計與概率)',
    nameEn: 'HKDSE Mathematics - Paper 3 (Statistics & Probability)',
    nameCn: 'HKDSE 数学 - 试卷3 (统计与概率)',
    nameJa: 'HKDSE 数学 - 試験3 (統計と確率)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試統計分析、概率計算和數據處理知識',
    modes: {
      examMode: { name: '考試模式', timeLimit: 135, showAnswers: false, allowReview: false, saveProgress: true },
      studyMode: { name: '自習模式', timeLimit: null, showAnswers: true, allowReview: true, saveProgress: true },
      preTestMode: { name: '預測模式', timeLimit: 135, showAnswers: false, allowReview: true, saveProgress: true }
    },
    questions: [
      {
        id: 1,
        question: "一組數據：3, 5, 7, 9, 11 的平均數是：",
        questionEn: "The mean of the data set: 3, 5, 7, 9, 11 is:",
        options: ["\\(7\\)", "\\(6\\)", "\\(8\\)", "\\(5\\)"],
        correctAnswer: 0,
        explanation: "平均數 = \\(\\frac{3 + 5 + 7 + 9 + 11}{5} = \\frac{35}{5} = 7\\)",
        explanationEn: "Mean = \\(\\frac{3 + 5 + 7 + 9 + 11}{5} = \\frac{35}{5} = 7\\)",
        difficulty: "easy",
        topic: "集中趨勢",
        hasMath: true
      },
      {
        id: 2,
        question: "投擲一枚公正硬幣兩次，兩次都是正面的概率是：",
        questionEn: "When flipping a fair coin twice, the probability of getting heads both times is:",
        options: ["\\(\\frac{1}{4}\\)", "\\(\\frac{1}{2}\\)", "\\(\\frac{1}{3}\\)", "\\(\\frac{3}{4}\\)"],
        correctAnswer: 0,
        explanation: "每次投擲正面的概率是 \\(\\frac{1}{2}\\)，兩次都是正面的概率是 \\(\\frac{1}{2} \\times \\frac{1}{2} = \\frac{1}{4}\\)",
        explanationEn: "Probability of heads each time is \\(\\frac{1}{2}\\), probability of heads both times is \\(\\frac{1}{2} \\times \\frac{1}{2} = \\frac{1}{4}\\)",
        difficulty: "easy",
        topic: "概率",
        hasMath: true
      },
      {
        id: 3,
        question: "數據集 {2, 4, 6, 8, 10} 的中位數是：",
        questionEn: "The median of the data set {2, 4, 6, 8, 10} is:",
        options: ["\\(6\\)", "\\(5\\)", "\\(7\\)", "\\(4\\)"],
        correctAnswer: 0,
        explanation: "中位數是排序後位於中間的數值。在5個數中，中位數是第3個數，即6",
        explanationEn: "The median is the middle value when arranged in order. In 5 numbers, the median is the 3rd number, which is 6",
        difficulty: "easy",
        topic: "集中趨勢",
        hasMath: true
      },
      {
        id: 4,
        question: "一個袋子裡有3個紅球和2個藍球，隨機抽取一個球是紅球的概率是：",
        questionEn: "A bag contains 3 red balls and 2 blue balls. The probability of randomly drawing a red ball is:",
        options: ["\\(\\frac{3}{5}\\)", "\\(\\frac{2}{5}\\)", "\\(\\frac{1}{2}\\)", "\\(\\frac{3}{2}\\)"],
        correctAnswer: 0,
        explanation: "總共5個球，其中3個是紅球，所以概率是 \\(\\frac{3}{5}\\)",
        explanationEn: "Total 5 balls, 3 are red, so probability is \\(\\frac{3}{5}\\)",
        difficulty: "easy",
        topic: "概率",
        hasMath: true
      },
      {
        id: 5,
        question: "數據集的標準差用來衡量：",
        questionEn: "Standard deviation of a data set measures:",
        options: ["數據的離散程度", "數據的平均值", "數據的最大值", "數據的中位數"],
        correctAnswer: 0,
        explanation: "標準差是衡量數據相對於平均值的離散程度或變異性的統計量",
        explanationEn: "Standard deviation is a statistic that measures the dispersion or variability of data relative to the mean",
        difficulty: "medium",
        topic: "變異性",
        hasMath: false
      },
      ...paper3RemainingQuestions
    ]
  }
]; 